import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from 'styled-components';

import { VerticalFullContainer } from 'Common/components/styled';
import BlueSpinner from 'Common/components/BlueSpinner';

const MainLayout = () => {
  return (
    <Layout>
      <Container>
        <Suspense
          fallback={
            <SpinnerContainer>
              <BlueSpinner />
            </SpinnerContainer>
          }
        >
          <Outlet />
        </Suspense>
      </Container>
    </Layout>
  );
};

const Layout = styled(VerticalFullContainer)`
  background: #F4F5F9;
  color: #1A1D2B;
  width: 100%;
  flex-direction: row;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const Container = styled(VerticalFullContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 100vh;
  width: 100%;
`;

export const Page = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
`;

const SpinnerContainer = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
`;

export default MainLayout;
